import runtimeEnv from "@mars/heroku-js-runtime-env";

// for our on prem server
// const env = process.env;
const env = runtimeEnv();

window.Api = {};

window.Api.Base = process.env.REACT_APP_API_BASE;

window.Api.User = {};

window.Api.User.Base = window.Api.Base + "/user";

window.Api.User.Login = window.Api.User.Base + "/login";
window.Api.User.Logout = window.Api.User.Base + "/logout";
window.Api.User.Info = window.Api.User.Base + "/info";
window.Api.Hashes = window.Api.Base + "/hashes";
window.Api.User.RequestResetPassword =
  window.Api.User.Base + "/requestResetPassword";
window.Api.User.ResetPassword = window.Api.User.Base + "/resetPassword";
window.Api.User.RefreshToken = window.Api.User.Base + "/refresh-token";

window.Api.Projects = window.Api.Base + "/projects";
window.Api.Filters = window.Api.Base + "/filters";
window.Api.Categories = window.Api.Base + "/categories";

window.Api.Images = window.Api.Base + "/images";
window.Api.Files = window.Api.Base + "/files";
window.Api.ImagesV2 = window.Api.Base + "/images/v2";
